<template>
  <v-card>
    <v-card-title>
      List of Inactive Care Groups ({{ items.length }})
      <v-btn small icon @click.native="dataRefresh">
       <v-icon>refresh</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-progress-linear
      :indeterminate="true"
      :active="showProgress">
    </v-progress-linear>
    <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        v-bind:search="search"
        v-bind:rows-per-page-items="rowsPerPage">
      <template slot="items" slot-scope="props">
        <td class="layout px-0">
          <v-btn small icon :to="{name: 'careGroupEdit'}">
            <v-icon small color="grey">more_horiz</v-icon></v-btn></td>
        <td class="text-xs-left">{{ props.item.customerAccount.customerName }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">
          <v-expansion-panel popout>
            <v-expansion-panel-content>
              <div slot="header">{{ props.item.address.unitNumber}} {{ props.item.address.streetAddress}}</div>
              <v-card class="grey lighten-4 pl-2, pr-2, mt-1, mb-1">
                <v-card-text>
                  {{ props.item.address.city}}
                </v-card-text>
                <v-card-text>
                  {{ props.item.address.province}}
                </v-card-text>
                <v-card-text>
                  {{ props.item.address.postalCode}}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
        <td class="text-xs-left">{{ props.item.phone.phone }}</td>
        <td class="text-xs-left">
          <v-expansion-panel popout>
            <v-expansion-panel-content>
              <div slot="header">{{ props.item.Support.firstName }} {{ props.item.Support.lastName }}</div>
              <v-card class="grey lighten-4 pl-2, pr-2, mt-1, mb-1">
                <v-card-text>
                  Phone: {{ props.item.Support.phone.phone}}
                </v-card-text>
                <v-card-text>
                  Email: {{ props.item.Support.email.email}}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </td>
        <td class="text-xs-right">{{ props.item.groupNatureType.description }}</td>
        <td class="text-xs-left">
          <v-dialog v-model="dialog" max-width="500px" hide-overlay lazy>
            <v-btn small icon slot="activator" @click.native="
              deleteId = props.item.careGroupId,
              deleteName = props.item.name,
              dialog = true">
              <v-icon small color="grey">redo</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                Do you want to set the care group
                <div class="red--text subheading">
                    {{ deleteName }}
                </div>to inactive
              </v-card-text>
              <v-spacer></v-spacer>
              <v-btn dark color="blue darken-1"
                @click.native="dialog = false">CANCEL</v-btn>
              <v-btn dark color="red darken-1"
              @click.native="reactivate()">CONFIRM ACTIVE</v-btn>
            </v-card>
          </v-dialog>
        </td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ errMsg }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import CareGroupService from '@/services/CareGroupService'

  export default {
    data () {
      return {
        errMsg: '',
        deleteId: 0,
        deleteName: '',
        showProgress: true,
        dialog: false,
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        rowsPerPage: [
          10,
          20,
          {"text": "All", "value": -1}
        ],
        headers: [
          { text: 'Edit',
            align: 'left',
            sortable: false,
            value: null},
          { text: 'Customer Account Name', align: 'left', value: 'customerAccount.customerName'},
          { text: 'Care Group Name', align: 'left', value: 'name' },
          { text: 'Address', align: 'left', value: 'address.streetAddress' },
          { text: 'Phone', align: 'left', value: 'phone.phone' },
          { text: 'Support Contact', align: 'left', value: 'Support.firstName' },
          { text: 'Group Nature Type', align: 'left', value: 'groupNatureType.description' },
          { text: 'Re-activate',
            align: 'left',
            sortable: false
          }
        ],
        items: []
      }
    },
    mixins: [mixins],
    async mounted () {
      try {
        this.dialog = false
        this.errMsg = ''
        this.showProgress = true
        this.items = (await CareGroupService.index({state: 1})).data
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.errMsg = this.handleError(error)
      }
    },
    methods: {
      async reactivate() {
        try {
          this.dialog = false
          this.errMsg = ''
          const response = await CareGroupService.state({
            careGroupId: this.deleteId,
            state: 0
          })
          this.showProgress = true
          this.items = (await CareGroupService.index({state: 1})).data
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      },
      async dataRefresh() {
        try {
          this.errMsg = ''
          this.dialog = false
          this.showProgress = true
          this.items = (await CareGroupService.index({state: 1})).data
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CareGroup/CareGroupListInactive.vue